<template>
  <td 
    v-bind="$attrs"
    :class="to !== undefined || href !== undefined ? null : ['bg-white','py-4','px-8','border-collapse','align-middle','text-gray-500']"
  >
    <a
      v-if="href !== undefined"
      :href="href"
      class="bg-white py-4 px-8 border-collapse align-middle flex items-center w-full text-gray-500"
    >
      <slot />
    </a>
    <a
      v-else-if="typeof to === 'string'"
      :href="to"
      class="bg-white py-4 px-8 border-collapse align-middle flex items-center w-full text-gray-500"
    >
      <slot />
    </a>
    <router-link
      v-else-if="to !== undefined"
      :to="to"
      class="bg-white py-4 px-8 border-collapse align-middle flex items-center w-full text-gray-500"
    >
      <slot />
    </router-link>
    <slot v-else />
  </td>
</template>

<script setup lang="ts">
import { RouterLink, type RouteLocationRaw } from 'vue-router';

interface FTdProps {
  to?: RouteLocationRaw;
  href?: string;
}

defineProps<FTdProps>();
</script>